var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mb-2 text-decoration-none",attrs:{"tag":"router-link","icon-pack":"fas","to":_vm.to,"type":_vm.type,"size":_vm.size,"icon-left":_vm.iconLeft}},[(_vm.label !== null)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }